import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonSharedModule } from 'common/common.module';
import { AppHttpClient } from 'common/service/app-http-client.service';

import { AnswerTypeModule } from '../answer-type/answer-type.module';
import { ClientFormInputContentListComponent } from './client-form-input-content-list.component';
import { FilterPipe } from '../pipe/filter.pipe';

@NgModule({
  declarations: [
    ClientFormInputContentListComponent,
    FilterPipe
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    CommonSharedModule,
    AnswerTypeModule,
  ],
  exports: [ClientFormInputContentListComponent],
  providers: []
})
export class ClientFormInputContentListModule { }
